const router = [
  {
    path: '/purmaterial_orders_list',
    name: 'FinishedProductAndMaterialOrderList',
    component: () => import('@/views/PurcManagement/FinishedProductAndMaterialOrder/List.vue'),
    meta: {
      title: '成品/物料订单 列表'
    }
  },
  {
    path: '/purmaterial_orders_edit',
    name: 'FinishedProductAndMaterialOrderEdit',
    component: () => import('@/views/PurcManagement/FinishedProductAndMaterialOrder/Edit.vue'),
    meta: {
      title: '成品/物料订单 编辑'
    }
  },
  {
    path: '/finishedProductMaterialOrderReminder',
    name: 'FinishedProductMaterialOrderReminder',
    component: () => import('@/views/PurcManagement/FinishedProductAndMaterialOrder/FinishedProductMaterialOrderReminder.vue'),
    meta: {
      title: '成品/物料订单 提醒'
    }
  }
];
export default router;
